module.exports = __webpack_public_path__ + "media/images/photo/plans/places/yamashita_park-5fbc04b18369d5925e81d4ad5296f313.png";